import React from "react";

const VideoTitle = ({ title, overview }) => {
  return (
    <div
      className="w-full absolute inset-0 text-white z-20 flex flex-col justify-center px-8 md:px-16"
      style={{
        background:
          "linear-gradient(77deg, rgba(0,0,0,.9) 0%, rgba(0,0,0,.6) 30%, transparent 55%)",
      }}
    >
      <h1 className="pt-[20%] md:pt-0 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold max-w-[45%] leading-tight tracking-tight drop-shadow-lg">
        {title}
      </h1>
      <p className="hidden md:inline-block mt-3 mb-4 text-xs md:text-sm lg:text-base w-[30%] lg:w-[25%] leading-relaxed line-clamp-3 text-gray-200 drop-shadow-md">
        {overview}
      </p>
      <div className="flex gap-2 mt-2 md:mt-3">
        <button
          className="py-1.5 md:py-2 px-3 md:px-5 text-xs md:text-sm lg:text-base font-bold rounded flex items-center gap-1.5 transition-all duration-200"
          style={{ backgroundColor: "#fff", color: "#000" }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#e0e0e0")
          }
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-5 h-5 md:w-6 md:h-6"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
          Play
        </button>
        <button
          className="text-white py-1.5 md:py-2 px-3 md:px-5 text-xs md:text-sm lg:text-base font-bold rounded flex items-center gap-1.5 transition-all duration-200"
          style={{ backgroundColor: "rgba(109, 109, 110, 0.7)" }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "rgba(109, 109, 110, 0.4)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "rgba(109, 109, 110, 0.7)")
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className="w-5 h-5 md:w-6 md:h-6"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
          More Info
        </button>
      </div>
    </div>
  );
};

export default VideoTitle;
